"use client";
import React from "react";
import { LazyMotion, domAnimation, m } from "framer-motion";

export interface PaginationProps {
  scrollSnaps: number[];
  selectedIndex: number;
  onDotButtonClick?: (index: number) => void;
}

const MAX_VISIBLE_DOTS = 5;

const Pagination: React.FC<PaginationProps> = ({
  scrollSnaps,
  selectedIndex,
  onDotButtonClick,
}) => {
  const totalSlides = scrollSnaps.length;

  // Calculate start and end index for pagination window
  let start = Math.max(0, selectedIndex - Math.floor(MAX_VISIBLE_DOTS / 2));
  let end = start + MAX_VISIBLE_DOTS;

  // If we exceed, shift the window
  if (end > totalSlides) {
    end = totalSlides;
    start = Math.max(0, end - MAX_VISIBLE_DOTS);
  }

  const visibleDots = scrollSnaps.slice(start, end);

  return (
    <LazyMotion features={domAnimation}>
      <div className="pagination flex gap-2 xlg:gap-1 transition-all items-center">
        {start > 0 && <span className="text-gray-400 text-xs">...</span>}

        {visibleDots.map((_, indexOffset) => {
          const index = start + indexOffset;
          const isActive = index === selectedIndex;

          return (
            <m.div
              key={index}
              onClick={() => onDotButtonClick?.(index)}
              layout
              className={`rounded-full cursor-pointer ${
                isActive
                  ? "w-10 h-2 bg-themeColor"
                  : "w-2 h-2 bg-[rgba(var(--primary-color-rgb),0.2)]"
              }`}
              transition={{ duration: 0.3 }}
            />
          );
        })}

        {end < totalSlides && (
          <span className="text-gray-400 text-xs">...</span>
        )}
      </div>
    </LazyMotion>
  );
};

export default Pagination;
